/**
 * Card Quick-Add Quantity Picker (delegated, safe against duplicate loads)
 *
 * Expects:
 * - wrapper: .js-qa-row
 * - minus:   .js-qa-minus
 * - plus:    .js-qa-plus
 * - input:   .js-qa-input
 * - (optional) drawer opener button in same row: .js-quick-add
 *   -> we sync its dataset.quickAddQty for the drawer to read
 */

(function initQuickAddQtyPicker() {
  // If this file is accidentally included multiple times, de-dupe listeners.
  if (window.__QA_QTY_PICKER_HANDLERS__) {
    document.removeEventListener("click", window.__QA_QTY_PICKER_HANDLERS__.onClick, true);
    document.removeEventListener("change", window.__QA_QTY_PICKER_HANDLERS__.onChange, true);
  }

  function clampQty(n) {
    const v = Number.isFinite(n) ? Math.floor(n) : 1;
    return Math.max(1, v);
  }

  function setQty(rowEl, qty) {
    const input = rowEl.querySelector(".js-qa-input");
    if (!input) return;

    const min = clampQty(parseInt(input.getAttribute("min") || "1", 10));
    const next = Math.max(min, clampQty(qty));
    input.value = String(next);

    // Keep drawer opener (choose-options button) in sync, if present
    const opener = rowEl.querySelector(".js-quick-add");
    if (opener) opener.dataset.quickAddQty = String(next);
  }

  function onClick(e) {
    const plusBtn = e.target.closest?.(".js-qa-plus");
    const minusBtn = e.target.closest?.(".js-qa-minus");
    if (!plusBtn && !minusBtn) return;

    // Stop stacked/duplicate handlers early (capture phase)
    e.preventDefault();
    e.stopImmediatePropagation();

    const row = e.target.closest?.(".js-qa-row");
    if (!row) return;

    const input = row.querySelector(".js-qa-input");
    const current = clampQty(parseInt(input?.value || "1", 10));
    const step = clampQty(parseInt(input?.getAttribute("step") || "1", 10));

    setQty(row, plusBtn ? current + step : current - step);
  }

  function onChange(e) {
    const input = e.target.closest?.(".js-qa-input");
    if (!input) return;

    const row = input.closest?.(".js-qa-row");
    if (!row) return;

    setQty(row, parseInt(input.value || "1", 10));
  }

  // Capture phase lets us stopImmediatePropagation before other listeners run.
  document.addEventListener("click", onClick, true);
  document.addEventListener("change", onChange, true);

  window.__QA_QTY_PICKER_HANDLERS__ = { onClick, onChange };
})();
